import React from 'react'

import { LabelValueTable } from '@app/components'
import { LntInput, LntDivider, LntFormItem } from '@app/components/base'

import { generateTableItems } from '@app/pages/ProcessingResultsPageInner/lib'

import { PERMISSION } from '@app/constants/permission'
import { useCheckPermissionAccess } from '@app/hooks'

import { titlesMap, targetKeys } from './configs'

import styles from './styles.module.scss'

import type { PricesBlockProps } from './types'

export const PricesBlock: React.FC<PricesBlockProps> = ({ data, disableInputs }) => {
  const discountData = generateTableItems({
    data,
    titlesMap,
    targetKeys
  })

  const canChangePrice = useCheckPermissionAccess({
    requiredPermissions: [PERMISSION.changeMonitoringResultsPrice]
  })

  return (
    <div className={ styles.pricesBlock }>
      <h5 className={ styles.pricesBlock__title }>Цена конкурента</h5>

      <div className={ styles.pricesBlock__item }>
        <LntFormItem
          name='regularPrice'
          label='Регулярная цена'
        >
          <LntInput
            type='number'
            disabled={ disableInputs.regularPrice || !canChangePrice }
          />
        </LntFormItem>
      </div>

      <div className={ styles.pricesBlock__item }>
        <LntFormItem
          name='promoPrice'
          label='Акционная цена'
        >
          <LntInput
            type='number'
            disabled={ disableInputs.promoPrice || !canChangePrice }
          />
        </LntFormItem>
      </div>

      <div className={ styles.pricesBlock__item }>
        <span className={ styles.pricesBlock__itemTitle }>Изначальная цена</span>
        { /* TODO: Обернуть в LntFormItem, как будет готов бэк принимать */ }
        <LntInput
          value={ data?.originalPrice ?? '' }
          disabled
        />
      </div>

      <div className={ styles.pricesBlock__item }>
        <span className={ styles.pricesBlock__itemTitle }>Примечание к акции/товару</span>
        { /* TODO: Обернуть в LntFormItem, как будет готов бэк принимать */ }
        <LntInput
          value={ data?.note ?? '' }
          disabled
        />
      </div>

      <LntDivider type='horizontal' />

      <h5 className={ styles.pricesBlock__title }>Скидка конкурента</h5>
      <LabelValueTable
        data={ discountData }
        hasSeparator
        columns={ 2 }
      />
    </div>
  )
}
